const getters = {
  sidebar: (state) => state.app.sidebar,
  device: (state) => state.app.device,
  language: (state) => state.app.language,
  token: (state) => state.user.token,
  avatar: (state) => state.user.avatar,
  username: (state) => state.user.username,
  roles: (state) => state.user.roles,
  permissions: (state) => state.user.permissions,
  routers: (state) => state.permissions.routers,
  addRouters: (state) => state.permissions.addRouters,
  is_open_company: (state) => state.user.is_open_company,
  is_self_use: (state) => state.user.is_self_use,
  is_show_cost: (state) => state.user.is_show_cost,
}
export default getters
